var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 20,
    height: 20,
    fill: "#fcfcfc",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-headphones",
    "data-name": "Icon feather-headphones",
    transform: "translate(-2.253 -2.253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37943",
    "data-name": "Path 37943",
    d: "M4.5,17.422V12.253a7.753,7.753,0,1,1,15.506,0v5.169",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37944",
    "data-name": "Path 37944",
    d: "M20.006,25.307a1.723,1.723,0,0,1-1.723,1.723h-.861A1.723,1.723,0,0,1,15.7,25.307V22.723A1.723,1.723,0,0,1,17.422,21h2.584Zm-15.506,0A1.723,1.723,0,0,0,6.223,27.03h.861a1.723,1.723,0,0,0,1.723-1.723V22.723A1.723,1.723,0,0,0,7.084,21H4.5Z",
    transform: "translate(0 -7.024)",
    fill: "none",
    stroke: "#fc3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileContactUs);
export default __webpack_public_path__ + "static/media/profile-contact-us.25f7c6f4c20141d55baae122a97bc6aa.svg";
export { ForwardRef as ReactComponent };